import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const GENERATE_QR_LOGIN_TICKET_URL = '/qr-login/generate/';

export interface QrLoginTicket {
    ticket: string;
    expiresIn: number;
}

@Injectable({
    providedIn: 'root'
})
export class QrLoginService {
    private _httpClient = inject(HttpClient);

    generateTicket$(totpToken?: string): Observable<QrLoginTicket> {
        const body = totpToken ? { totpToken: totpToken } : {};
        return this._httpClient.post<QrLoginTicket>(GENERATE_QR_LOGIN_TICKET_URL, body);
    }
}
